<template>
  <div class="row mt-3">
    <div class="col-12 col-lg-6">
      <div
        v-for="group in leftGroups"
        :key="'standard_' + group.name"
      >
        <h5 class="text-uppercase mb-3">
          {{ group.name }}
        </h5>
        <div class="box-content mb-5">
          <div
            v-for="item in group.items"
            :key="'standard_' + item.name"
            class="row box-row"
          >
            <div class="col box-label d-flex justify-content-between">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-6">
      <div
        v-for="group in rightGroups"
        :key="'standard_' + group.name"
      >
        <h5 class="text-uppercase mb-3">
          {{ group.name }}
        </h5>
        <div class="box-content mb-5">
          <div
            v-for="item in group.items"
            :key="'standard_' + item.name"
            class="row box-row"
          >
            <div class="col box-label d-flex justify-content-between">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import _ from 'lodash';
  import { Component, Prop } from 'vue-property-decorator';

  @Component
  export default class StandardEquipments extends Vue {
    @Prop(Object) standardEquipments;

    groups = [];

    created() {
      const prepared = _.mapValues(this.standardEquipments, (value, index) => {
        return {
          items: [...value],
          name: index
        };
      });

      this.groups = _.values(prepared);
    }

    get leftGroups() {
      const pivot = _.ceil(this.groups.length / 2);
      const items = _.chunk(this.groups, pivot);

      return items[0];
    }

    get rightGroups() {
      const pivot = _.ceil(this.groups.length / 2);
      const items = _.chunk(this.groups, pivot);

      return items[1];
    }
  }

</script>
